"use strict";

exports.__esModule = true;
exports.default = void 0;
var isSchema = function isSchema(obj) {
  return obj && obj.__isYupSchema__;
};
var _default = exports.default = isSchema;